import { TooltipV2, Button, ButtonDropdown } from '@cimplico/components';

type ChecklistItemsPagePrimaryActionsProps = {
    onEditTemplateClick: () => void;
    onSetDefaultClick: () => void;
    onNewChecklistItemClick: () => void;
    onNewCategoryClick: () => void;
    onSyncChecklistClick: () => void;
    onDeleteChecklistClick: () => void;
    onDownloadChecklistClick: () => void;
    disableEditButton?: boolean;
    disabledEditButtonHint?: string;
    disableDefaultButton?: boolean;
    disabledDefaultButtonHint?: string;
    disablePrimaryButton?: boolean;
    disabledPrimaryButtonHint?: string;
    disableSyncButton?: boolean;
    disabledSyncButtonHint?: string;
    disableDeleteButton?: boolean;
    disableDeleteButtonHint?: string;
    disableDownloadButton?: boolean;
    disableDownloadButtonHint?: string;
};

function ChecklistItemsPagePrimaryActions({
    onEditTemplateClick,
    onSetDefaultClick,
    onNewChecklistItemClick,
    onNewCategoryClick,
    onSyncChecklistClick,
    onDeleteChecklistClick,
    onDownloadChecklistClick,
    disableEditButton = false,
    disabledEditButtonHint = '',
    disableDefaultButton = false,
    disabledDefaultButtonHint = '',
    disablePrimaryButton = false,
    disabledPrimaryButtonHint = '',
    disableSyncButton = false,
    disabledSyncButtonHint = '',
    disableDeleteButton = false,
    disableDeleteButtonHint = '',
    disableDownloadButton = false,
    disableDownloadButtonHint = '',
}: ChecklistItemsPagePrimaryActionsProps): JSX.Element {
    return (
        <div className="flex gap-4 items-center">
            <TooltipV2 message={disableDeleteButtonHint} disabled={!disableDeleteButtonHint} position="left">
                <Button type="danger" label="Delete" onClick={onDeleteChecklistClick} disabled={disableDeleteButton} size="sm" />
            </TooltipV2>
            <TooltipV2 message={disabledDefaultButtonHint} disabled={!disabledDefaultButtonHint} position="left">
                <Button type="secondary" label="Set as Default" onClick={onSetDefaultClick} disabled={disableDefaultButton} size="sm" />
            </TooltipV2>
            <TooltipV2 message={disabledSyncButtonHint} disabled={!disabledSyncButtonHint} position="left">
                <Button
                    type="secondary"
                    label="Sync to Open Workpapers"
                    onClick={onSyncChecklistClick}
                    disabled={disableSyncButton}
                    size="sm"
                />
            </TooltipV2>
            <TooltipV2 message={disabledEditButtonHint} disabled={!disabledEditButtonHint} position="left">
                <Button type="secondary" label="Edit Checklist" onClick={onEditTemplateClick} disabled={disableEditButton} size="sm" />
            </TooltipV2>
            <TooltipV2 message={disableDownloadButtonHint} disabled={!disableDownloadButtonHint} position="left">
                <Button
                    type="secondary"
                    label="Download Checklist"
                    onClick={onDownloadChecklistClick}
                    disabled={disableDownloadButton}
                    size="sm"
                />
            </TooltipV2>
            <TooltipV2 message={disabledPrimaryButtonHint} disabled={!disabledPrimaryButtonHint} position="left">
                <ButtonDropdown
                    variant="primary"
                    label="New Item"
                    onClick={onNewChecklistItemClick}
                    disabled={disablePrimaryButton}
                    size="sm"
                >
                    <ButtonDropdown.SecondaryAction label="New Category" onClick={onNewCategoryClick} />
                </ButtonDropdown>
            </TooltipV2>
        </div>
    );
}
export default ChecklistItemsPagePrimaryActions;
